/**
 * OnboardingBenefitCard.tsx - Reusable benefit card for onboarding intro
 * Displays an icon with title and subtitle in a row layout
 */
import React, { ReactNode } from "react";
import { View } from "react-native";
import CustomText from "../../../common/general/CustomText/CustomText";
import { spacing, radii, colors as designColors } from "../../../../styles/design-system";

export interface OnboardingBenefitCardProps {
  icon: ReactNode;
  titleKey: string;
  subtitleKey: string;
  iconBackgroundColor: string;
}

function OnboardingBenefitCard({ icon, titleKey, subtitleKey, iconBackgroundColor }: OnboardingBenefitCardProps) {
  return (
    <View
      style={{
        flexDirection: "row",
        gap: spacing.md,
        alignItems: "flex-start",
        backgroundColor: designColors.grey[50],
        borderRadius: radii.full,
        padding: spacing.md,
      }}>
      <View
        style={{
          width: 48,
          height: 48,
          borderRadius: radii.full,
          backgroundColor: iconBackgroundColor,
          justifyContent: "center",
          alignItems: "center",
          marginTop: 2,
          flexShrink: 0,
        }}>
        {icon}
      </View>
      <View style={{ flex: 1, gap: spacing.xxs }}>
        <CustomText text={titleKey} size="m" style={{ color: designColors.grey[700] }} />
        <CustomText text={subtitleKey} size="s" style={{ color: designColors.grey[500] }} />
      </View>
    </View>
  );
}

export default OnboardingBenefitCard;
